module.exports = "/images/loading.gif";